import { Injectable } from '@angular/core';

import { IntegrationsClientHttpBase } from '@recruitee/integrations/http';

@Injectable({ providedIn: 'root' })
export class CoreApiService extends IntegrationsClientHttpBase {
  public get baseUrl(): string {
    return `${this.config.apiUrl}/c/${this.integrationsCredentials.companyId}`;
  }

  protected httpOptions(): { headers: { [name: string]: string } } {
    const base = super.httpOptions();

    return {
      ...base,
      headers: {
        ...base.headers,
        'x-recruitee-client': this.config.isE2e ? 'Integrations - e2e' : 'Integrations',
        'x-recruitee-env': this.config.environmentName,
      },
    };
  }
}
